import {ShipmentsEffects} from './shipments.effect';
import {SnackbarEffects} from "@store/effects/snackbar.effect";
import {AddressesEffects} from "@store/effects/addresses.effect";
import {ProfileEffects} from "@store/effects/profile.effect";
import {FooterEffects} from "@store/effects/footer.effect";

export const effects = [
  ShipmentsEffects,
  SnackbarEffects,
  AddressesEffects,
  ProfileEffects,
  FooterEffects
];



// WEBPACK FOOTER //
// ./src/app/store/effects/index.ts